import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { text, timer } from '../PayconiqRedirect.scss';
import QrComponent from '../QrComponent/QrComponent';

import {
  TXTWCL_Please_scan_the_QR_code_to_con_ELL,
  TXTWCL_QR_code_expires_inX_N0,
  TXTWCL_You_will_be_redirected_to_the__ELL_1,
  TXTWCL_Your_transaction_is_being_proc_ELL
} from './CommonLayout.messages.json';

interface Props {
  payconiqColor: string;
  qrCodeData?: string;
  remainTime: JSX.Element;
}

const CommonLayout = ({ payconiqColor, qrCodeData, remainTime }: Props) => (
  <>
    <div className={text}>
      <Translation tagName="h2" {...TXTWCL_Your_transaction_is_being_proc_ELL} />
      <p>
        <Translation tagName="span" {...TXTWCL_You_will_be_redirected_to_the__ELL_1} />
        <Translation tagName="span" {...TXTWCL_Please_scan_the_QR_code_to_con_ELL} />
      </p>
    </div>
    <p className={timer}>
      <Translation values={{ 0: remainTime }} {...TXTWCL_QR_code_expires_inX_N0} />
    </p>
    {qrCodeData && <QrComponent qrCodeData={qrCodeData} payconiqColor={payconiqColor} />}
  </>
);

export default CommonLayout;
